export default "__VITE_ASSET__K$HeBiDK__"